"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPClientTransport = void 0;
var auth_1 = require("../auth");
var logger_1 = require("../../logger");
var HTTPClientTransport = (function () {
    function HTTPClientTransport(endpoint, marshaller, logger) {
        if (logger === void 0) { logger = undefined; }
        this.setEndpoint(endpoint);
        this.timeout = 60 * 1000;
        this.logger = logger;
        if (!this.logger) {
            this.logger = new logger_1.DummyLogger();
        }
        this.marshaller = marshaller;
        this.headers = {};
    }
    Object.defineProperty(HTTPClientTransport.prototype, "isReady", {
        get: function () {
            if (typeof this.endpoint == 'undefined') {
                return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    HTTPClientTransport.prototype.doRequest = function (url, payload, successCallback, failureCallback) {
        var req = new XMLHttpRequest();
        req.onreadystatechange = function () {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    successCallback(req.responseText);
                }
                else {
                    failureCallback(req.responseText);
                }
            }
        };
        if (payload) {
            req.open('POST', url, true);
            this.logger.logf(logger_1.LogLevel.Debug, 'Header: Content-type: application/json');
            req.setRequestHeader('Content-type', 'application/json');
        }
        else {
            req.open('GET', url, true);
        }
        if (this.headers) {
            for (var key in this.headers) {
                if (!this.headers.hasOwnProperty(key)) {
                    continue;
                }
                req.setRequestHeader(key, this.headers[key]);
            }
        }
        if (this.auth) {
            req.setRequestHeader('Authorization', this.auth.toValue());
            this.logger.logf(logger_1.LogLevel.Debug, 'Header: Authorization: ' + this.auth.toValue());
        }
        req.timeout = this.timeout;
        req.send(payload);
    };
    HTTPClientTransport.prototype.sanitizeEndpoint = function (endpoint) {
        if (!endpoint || endpoint.length === 0) {
            return endpoint;
        }
        if (endpoint.endsWith('/') || endpoint.endsWith('\\')) {
            endpoint = endpoint.substr(0, endpoint.length - 1);
        }
        return endpoint;
    };
    HTTPClientTransport.prototype.setEndpoint = function (endpoint) {
        this.endpoint = this.sanitizeEndpoint(endpoint);
    };
    HTTPClientTransport.prototype.setHeaders = function (headers) {
        this.headers = headers || {};
    };
    HTTPClientTransport.prototype.getHeaders = function () {
        return this.headers;
    };
    HTTPClientTransport.prototype.getAuthorization = function () {
        return this.auth ? this.auth.method : undefined;
    };
    HTTPClientTransport.prototype.setAuthorization = function (method) {
        if (!method) {
            this.auth = undefined;
            return;
        }
        this.auth = new auth_1.Authorization();
        this.auth.method = method;
    };
    HTTPClientTransport.prototype.setTimeout = function (timeout) {
        this.timeout = timeout;
    };
    HTTPClientTransport.prototype.send = function (service, method, data) {
        var _this = this;
        if (!this.isReady) {
            return new Promise(function (resolve, reject) {
                reject("Transport has not been initialized or endpoint is undefined.");
            });
        }
        this.logger.logf(logger_1.LogLevel.Debug, '====================================================');
        this.logger.logf(logger_1.LogLevel.Debug, 'Requesting ' + service + ' service, method ' + method);
        return new Promise(function (resolve, reject) {
            var url = "".concat(_this.endpoint, "/").concat(service, "/").concat(method);
            var payload = data.serialize();
            var payloadHasNoData = Object.keys(payload).length === 0 && payload.constructor === Object;
            var json = payloadHasNoData ? null : _this.marshaller.Marshal(payload);
            _this.logger.logf(logger_1.LogLevel.Debug, 'Endpoint: ' + url);
            _this.logger.logf(logger_1.LogLevel.Debug, 'Method: ' + (payloadHasNoData ? 'GET' : 'POST'));
            if (json !== null) {
                _this.logger.logf(logger_1.LogLevel.Trace, 'Request Body:\n' + json);
            }
            if (_this.onSend) {
                _this.onSend(service, method, json);
            }
            _this.doRequest(url, json, function (successContent) {
                _this.logger.logf(logger_1.LogLevel.Trace, 'Response body:\n' + successContent);
                if (_this.onSuccess) {
                    _this.onSuccess(service, method, successContent);
                }
                var content = _this.marshaller.Unmarshal(successContent);
                resolve(content);
            }, function (failureContent) {
                _this.logger.logf(logger_1.LogLevel.Error, 'Failure:\n' + failureContent);
                if (_this.onFailure) {
                    _this.onFailure(service, method, failureContent);
                }
                reject(failureContent);
            });
        });
    };
    return HTTPClientTransport;
}());
exports.HTTPClientTransport = HTTPClientTransport;
//# sourceMappingURL=transport.http.client.js.map